export function toISODateString(date: Date) {
  return date.toISOString().slice(0, 10);
}
